import cartAPI from 'apis/cart';

import type { CartBilling } from './cart_billing.types';

export const get = async () => {
  const { data } = await cartAPI.get<CartBilling>('/billing');
  return data;
};
